import angular from 'angular';
import controller from './radio.controller';
import template from './radio.html';
import RadioComponent from './radio.component';
import './radio.scss';

const radioConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('radio', {
		title: 'Radio',
		template,
		/**
		 * @param {any} data
		 * @param {any} options
		 * @returns {any}
		 */
		tableView(data, options) {
			// eslint-disable-next-line unicorn/no-array-for-each
			Object.keys(options.component.values).forEach(index => {
				if (
					Object.prototype.hasOwnProperty.call(options.component.values, index)
					&& options.component.values[index].value === data
				) {
					return options.component.values[index].label;
				}
				return null;
			});
			return data;
		},
		children:                   false,
		selectable:                 true,
		settings:                   new RadioComponent(),
		icon:                       'fa fa-dot-circle-o',
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/radio/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app')
	.config(radioConfig);
